import { IModules } from '~/lib/data-contract';

/**
 * Useful for detecting if the first module should blend with the top menu
 */
export const getIsModuleHero = (module?: IModules, checkForM11?: boolean): boolean => {
	// You'd think we should check for the M11 here as well, right? No. Because that thing needs special treatment,
	// because it needs to position the logo very carefully, so we should handle that differently. And we will.
	return module?.type === 'm10HeroModule' || (Boolean(checkForM11) && module?.type === 'm11HeroModule');
};
